import { messageBus, events } from '@schibsted-nmp/advertising-events';
import {
  Afs,
  PlacementInstructionConfig
} from '@schibsted-nmp/advertising-shared';

let interval;

type CompanionReadyPlacementListenerProps = {
  placementInstructionConfigs: PlacementInstructionConfig[];
  afs?: Afs;
};

export function companionReadyPlacementListener({
  placementInstructionConfigs,
  afs
}: CompanionReadyPlacementListenerProps) {
  function publishPodletReady() {
    messageBus.publish(
      events.COMPANION.channel,
      events.COMPANION.PODLET_READY.topic,
      events.COMPANION.PODLET_READY.sendPayload({
        placementInstructionConfigs
      })
    );
    if (afs) {
      messageBus.publish(
        events.ADVERTISING.channel,
        events.ADVERTISING.AFS_CONFIG.topic,
        events.ADVERTISING.AFS_CONFIG.sendPayload({
          afs
        })
      );
    }
  }

  // Initial in case of early publish
  publishPodletReady();
  interval = setInterval(() => {
    publishPodletReady();
  }, 200);

  // Clear the interval after 2000ms
  setTimeout(() => {
    clearInterval(interval);
  }, 2000);
}
